import { PostCoverEditEventTrack } from '../domain/dtos/post-cover-edit-event-track'

export const makePostContentCoverData = (data: PostCoverEditEventTrack) => ({
  userId: data.userId,
  creatorId: data.creatorId,
  productId: data.productId,
  postId: data.postId,
})
